import Swiper from "swiper";
// import { FreeMode, Mousewheel } from "swiper/modules";

export class NewsSlider {
	constructor(el) {
		this.el = el;
		this.init();
	}

	init() {
		this.swiper = new Swiper(this.el, {
      slidesPerView: "1.1",
      spaceBetween: 40,
      // modules: [FreeMode, Mousewheel],
      breakpoints: {
        576: {
          slidesPerView: "1.5",
        },
        768: {
          slidesPerView: "2.2",
        },
        992: {
          slidesPerView: "3.15",
          spaceBetween: 60,
        },
        1400: {
          slidesPerView: "4",
        },
      },
    });
	}
}
